import { reactive } from "@vue/composition-api";

export default function menuStore() {
  type state = {};
  const state = reactive({
    AntiSocial: {
      Content: [
        '1. 反社会的勢力に対しては、社内規定等に明文の根拠を設け、経営層をはじめ、 組織全体として対応します。また、反社会的勢力に対応する社員の安全を確保します。',
        '2. 反社会的勢力の排除に関し、警察、暴力追放運動推進センター、弁護士等の外部の専門機関と緊密な連携関係を構築することに努めます。',
        '3. 反社会的勢力に対しては、取引関係を含めて、一切の関係を遮断します。',
        '4. 反社会的勢力による不当要求には一切応じず、不当要求が認められた場合には、必要に応じて民事および刑事の両面から法的対応を行います。',
        '5. 反社会的勢力に対して、裏取引や資金提供は一切行いません'
      ],
      Header: '株式会社キュリカは、以下のとおり反社会的勢力に対する基本方針を定め、 社員一同これを遵守することにより、業務の適切性と安全性の確保に努めます。'
    },
    PrivacyPolicy: [
      {
        title: "１．関係法令・ガイドライン等の遵守",
        content:` 当社は、事業を通じて得た特定個人情報等を含む個人情報（以下「個人情報」といいます）の取扱いに関し、
        『番号法』および『個人情報の保護に関する法律（以下「個人情報保護法」といいます）』など関係諸法令並びに指針、 各省庁のガイドラインおよびその他の規範を遵守いたします。`
      },
      {
        title: "２．個人情報の収集・利用・提供について",
        content:`当社は、適切・適法かつ公正な手段によって個人情報の入手・利用・提供を行います。 また、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わず、そのための措置を講じます。
        その際、規格の要求する事項については、個人情報の主体である本人にその項目を通知し本人の同意を必ずいただくこととします。`
      },
      {
        title: "３．個人情報の適正管理について",
        content:`当社は、個人情報保護法をはじめとする法令・国が定める指針その他の規範を遵守し、取扱う個人情報を安全かつ適切に管理し、 個人情報への不正アクセス、個人情報の紛失、
        破壊、改ざんおよび漏えい等を防止するために、不正アクセス対策、 ウィルス対策等の必要かつ合理的な情報セキュリティ対策を行い、個人情報に関するリスクの予防並びに是正に努めます。`
      },
      {
        title: "４．個人情報保護マネジメントシステムの継続的改善について",
        content:`当社は、規格に準拠した個人情報保護マネジメントシステム（本方針･個人情報保護に関する規程・情報管理に関する規程およびその他の規程を含む）を 実行・維持するとともに、
        定期的に内容を見直し、継続的改善に努めます。`
      },
      {
        title: "５．お問い合わせ窓口について",
        content:`個人情報に関する問い合わせ・ご相談・開示の請求等に関する窓口を以下のとおり設置します。`
      }
    ],
  });

  return {
    get AntiSocial() {
      return state.AntiSocial
    },
    get PrivacyPolicy() {
      return state.PrivacyPolicy
    },
  }
}

export type MenuStore = ReturnType<typeof menuStore>;